import { createSelector } from 'reselect';

const loginState = state => state.login;

export const getUserRole = createSelector([loginState], login => login.role);
export const getAuthStatus = createSelector(
  [loginState],
  login => login.authenticated
);
